import { render, staticRenderFns } from "./CancellationInitForm.vue?vue&type=template&id=7e2255b4&scoped=true"
import script from "./CancellationInitForm.vue?vue&type=script&lang=js"
export * from "./CancellationInitForm.vue?vue&type=script&lang=js"
import style0 from "./CancellationInitForm.vue?vue&type=style&index=0&id=7e2255b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2255b4",
  null
  
)

export default component.exports